<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="ASP排产池实时监测（面积）"
      rightTitle="2022年12月合计：888"
    ></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
    <div id="left_2" slot="main"/>
     </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "left_2",
  components: { ChartTitle,DateChangeCard },
  data() {
    return {
      chart: null,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("left_2"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
          top: "20%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        color: [
          "#1158a7",
          "#4682B4",
          "#0983ff",
          "#59abf6",
          "#abd6fc",
          "#29beb9",
          "#3bffd0",
          "#22e4ff",
          "#40E0D0",
          "#AFEEEE",
        ],
        series: [
          {
            name: "PDM各类别板材工厂用量",
            type: "pie",
            radius: "55%",
            left: "20%",
            top: "top",
            data: [
              { value: 248, name: "系统排产池" },
              { value: 735, name: "板材超市排产池" },
              { value: 580, name: "售后排产池" },
              { value: 484, name: "特殊件排产池" },
              { value: 100, name: "加急排产池" },
              { value: 600, name: "无需排产池" },
              { value: 200, name: "实木排产池" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}: \n {@2012}",
              color: "#C0C4CC",
            },
            labelLine: {
              length: 5,
            },
          },
        ],
      });
    },
     //前一月
    leftClick() {
      console.log("leftClick");
    },
    //后一月
    rightClick() {
      console.log("rightClick");
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 36vh;
  #left_2 {
    height: 100%;
  }
}
</style>
